import React, { createContext, useState } from "react";
import { Modal, Button } from "react-bootstrap";

interface ChangeDectionContextType {
  changed: boolean;
  setChanged: (changed: boolean, newObject: any) => void; // Modificado aquí
  setOriginalObject: (original: any) => void;
  showModal: (onConfirm: () => void, onCancel?: () => void) => void;
  hideModal: () => void;
}

export const ChangeDectionContext = createContext<ChangeDectionContextType>({
  changed: false,
  setChanged: () => {},
  setOriginalObject: () => {},
  showModal: () => {},
  hideModal: () => {},
});

interface ChangeDectionProviderProps {
  children: React.ReactNode;
}

export const ChangeDectionProvider: React.FC<ChangeDectionProviderProps> = ({
  children,
}) => {
  const [changed, setChangedState] = useState<boolean>(false);
  const [originalObject, setOriginalObjectState] = useState<any>(null);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [onConfirmCallback, setOnConfirmCallback] = useState<() => void>(
    () => {}
  );
  const [onCancelCallback, setOnCancelCallback] = useState<() => void>(
    () => {}
  );

  // Function to set the original object for comparison
  const setOriginalObject = (original: any) => {
    setOriginalObjectState(original);
    setChangedState(false); // Reset the changed state when setting a new object
  };

  // Function to check if the new object differs from the original
  const setChanged = (changed: boolean, newObject: any) => {
    if (!changed) {
      setChangedState(false);
      return;
    }
    const isDifferent = JSON.stringify(newObject) !== JSON.stringify(originalObject);
    setChangedState(isDifferent);
  };

  // Show confirmation modal
  const showModal = (onConfirm: () => void, onCancel?: () => void) => {
    setOnConfirmCallback(() => onConfirm);
    setOnCancelCallback(() => onCancel || (() => {}));
    setModalVisible(true);
  };

  // Hide modal
  const hideModal = () => {
    setModalVisible(false);
    setOnConfirmCallback(() => {});
    setOnCancelCallback(() => {});
  };

  // Handle modal confirm action
  const handleConfirm = () => {
    onConfirmCallback();
    setChangedState(false);
    hideModal();
  };

  // Handle modal cancel action
  const handleCancel = () => {
    onCancelCallback();
    hideModal();
  };

  const value = {
    changed,
    setChanged,
    setOriginalObject,
    showModal,
    hideModal,
  };

  return (
    <ChangeDectionContext.Provider value={value}>
      {children}
      <Modal show={modalVisible} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Has realizado cambios en el formulario. Si no guardas antes de cambiar
          de página, perderás los cambios.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    </ChangeDectionContext.Provider>
  );
};
